
import {throwError as observableThrowError,  Observable } from 'rxjs';
import { Injectable, OnDestroy, Output, EventEmitter } from '@angular/core'
//import { Http } from '@angular/http'
import { HttpClient } from '@angular/common/http'
import { AuthService } from './auth.service'
import { appStateProvider } from '../insa-providers/AppStateProvider'
import { appConfig } from '../../insaweb.config'
import { LocalizeService } from './localize.service';
import {SharedMethodsModule} from '../insa-custom-scripts/sharedMethods';
import { MainWindowSearchCriteriaModel } from '../insa-models/mainWindowSearchCriteria.model'
import { catchError } from 'rxjs/operators';

@Injectable()
export class InsaMainService implements OnDestroy{

    //private language = 'en';
    private hostAddress = appConfig.insaServiceAddress;
    private servicesURL = "/InsaCron";
    authServiceSubscription;
    jobActivities: any;

    constructor(private _appStateProvider: appStateProvider, private http: HttpClient, private _authService: AuthService, private _localize: LocalizeService) {
       /* this.language = this._localize.getLocale().substring(0, 2);
        this.authServiceSubscription = this._authService.LoggedInStatusChangedEmitter.subscribe((loggedIn) => {
            if(loggedIn.value === false){
                this.language = this._localize.getLocale().substring(0, 2);
            }
  
        });*/
    }
   
    setMainWindowSearchCriteria (criteria: MainWindowSearchCriteriaModel) {
        let headers = this._authService.getAuthHeaders('application/json');

        let body = JSON.stringify(criteria);
        let req = this.http.post(this.hostAddress + this.servicesURL + '/MainWindowSearch', body, { headers })
            .pipe(
                catchError(err => this.handleError(err, "Could not set search chritera")))
            //.map(res => res.json())
        return req;        
    }


    private handleError(error: any, message: string) {
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
            SharedMethodsModule.addNotification("#notification", message, false);  
        return observableThrowError(errMsg);
    }

    ngOnDestroy() {
        //this.stateSubscription.unsubscribe();
        //this.authServiceSubscription.unsubscribe();
    }
}


// WEBPACK FOOTER //
// ./app/insa-services/insa-main.service.ts